import capitalize from 'lodash.capitalize';
import { topicsWithSubTopics } from 'topics';

const mapPageToAmplitudeName = (
  subPage: string,
  mainPage: string | undefined
): string => {
  if (subPage === '') return 'Homepage';
  if (mainPage === 'list') return 'Custom List';
  if (!mainPage) {
    if (subPage === 'faqActivityTracker') return 'FAQ Activity Tracker';
    if (subPage === 'playlistActivity') return 'Playlist Activity';
    return capitalize(subPage);
  }

  const topic = topicsWithSubTopics.find((t: any) => t.value === mainPage);
  if (topic) {
    const subTopic = topic?.children?.find((c: any) => c.value === subPage);
    return `${topic.label}/${subTopic?.label}`;
  } else {
    return `${capitalize(mainPage)}/${capitalize(subPage)}`;
  }
};

export default mapPageToAmplitudeName;
